import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: theme.spacing(4),
    marginBottom: theme.spacing(12.5),
  },
  horizontalDivider: {
    height: '1px',
    backgroundColor: theme.palette.dividerV2.main,
    marginLeft: theme.spacing(-4),
    marginRight: theme.spacing(-4),
  },
  cardHeadingWrapper: {
    gap: theme.spacing(2),
  },
}))
